import React from 'react'
import { func, string } from 'prop-types'
import Modal from '../Modal/Modal'
import IcoCalendar from '../icons/IcoCalendar'
import { BtnGhost, BtnPrimary } from '../ui/buttons'
import { theme } from '../../styles'
import { Callout } from './cancel-flow-styles'

export default function CancelStatusInfo( { situacao, renewLong, onClose, onUndo, onReactivate } ) {
  const jaCancelada = situacao === 'cancelada'

  const texto = ( () => {
    if ( jaCancelada ) {
      return 'Sua assinatura foi cancelada. Seu histórico de leituras fica guardado caso queira voltar.'
    }
    if ( renewLong ) {
      return <>Cancelamento agendado. Sua assinatura segue ativa até <b>{ renewLong }</b>.</>
    }
    return 'Cancelamento agendado. Sua assinatura segue ativa até o final da vigência atual.'
  } )()

  const footer = (
    <>
      <BtnGhost
        onClick={ onClose }
        type="button"
      >Fechar
      </BtnGhost>
      <BtnPrimary
        onClick={ jaCancelada ? onReactivate : onUndo }
        type="button"
      >
        { jaCancelada ? 'Reativar' : 'Desfazer cancelamento' }
      </BtnPrimary>
    </>
  )

  return (
    <Modal
      footer={ footer }
      onClose={ onClose }
      title={ jaCancelada ? 'Assinatura cancelada' : 'Cancelamento agendado' }
    >
      <Callout>
        <IcoCalendar
          height="20"
          style={{ 'color': theme.cores.accent, 'flex': 'none' }}
          width="20"
        />
        <span>{ texto }</span>
      </Callout>
    </Modal>
  )
}

CancelStatusInfo.propTypes = {
  'situacao': string.isRequired,
  'renewLong': string,
  'onClose': func.isRequired,
  'onUndo': func,
  'onReactivate': func
}

CancelStatusInfo.defaultProps = {
  'renewLong': '',
  'onUndo': null,
  'onReactivate': null
}
